/**
 * Chart Modal Backdrop Component
 *
 * Click-outside-to-close backdrop with fade animation
 */

import { motion } from 'framer-motion';

interface ChartModalBackdropProps {
  onClick: () => void;
}

export function ChartModalBackdrop({ onClick }: ChartModalBackdropProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      onClick={onClick}
      className="fixed inset-0 bg-black/75 z-40"
      style={{ backdropFilter: 'blur(4px)' }}
    />
  );
}
